export const getParamValue = (paramName: string) => {
	if (window.location.hash) {
		let query = window.location.hash.split("?")[1]; //get querystring
		let qArray = query && query.split('&'); //get key-value pairs
		if (qArray) {
			for (let i = 0; i < qArray.length; i++) {
				let pArr = qArray[i].split('='); //split key and value
				if (pArr[0] === paramName) {
					return pArr[1]; //return param value
				}
			}
		}
	}
	return "";
}
